import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const items = [
  {
    title: 'Para Danimar',
    text: 'Presencia masiva en una plataforma de streaming líder por una fracción del costo de mercado. El canje coloca productos en un entorno de alto tráfico (nuestra sede) como muestra real de calidad.',
  },
  {
    title: 'Para TNO Network',
    text: 'Limpieza e higiene de las instalaciones con productos de primera, manteniendo la marca en rotativa de alta frecuencia.',
  },
  {
    title: 'Mística y alianza',
    text: 'Danimar no es solo un anunciante: es el proveedor oficial de limpieza de TNO —un sello de garantía implícito para la marca.',
  },
];

const WinWinExpress = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alianza
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Por qué es ganar-ganar
      </Typography>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700} color="primary">
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WinWinExpress;
